import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import CreateLicense from './CreateLicense';
import Confirmation from './Confirmation';
import { showConfirmation } from '../../actions';
import CancelLicense from './CancelLicense';
import Button from '../../../Share/components/Button';
import { useNavigate } from 'react-router';
import ErrorModal from './ErrorModal';
import { FETCH_LICENSE_USERS_ERROR } from '../../actions/ActionTypes';

function ManageLicenseList({
  licenses = [],
  handleCancelLicense = () => {},
  licenseTypes = [],
  handleChangeLicense = () => {},
}) {
  const navigate = useNavigate();
  const getLicenseOption = (action, license) => {
    const type =
      licenseTypes &&
      licenseTypes.find(
        lt => lt.LicenseTypeIdentifier === license.LicenseTypeIdentifier,
      );

    if (!type) return false;

    if (action === 'upgrade') {
      return type.Pricings.some(
        p => p.NumberOfLicenses > license.NumberOfLicenses,
      );
    } else if (action === 'downgrade') {
      if (license.DateValidTo) return false;
      return type.Pricings.some(
        p => p.NumberOfLicenses < license.NumberOfLicenses,
      );
    } else {
      return false;
    }
  };

  return (
    <div className="tv-contactperson__list-wrapper">
      {licenses && licenses.length > 0 ? (
        licenses.map(license => (
          <div
            className="row  custom tv-reportquality__list-item  mb-0"
            key={license.LicenseIdentifier}
          >
            <div
              className="row px-0 mx-0 w-100 tv-display-mobile-hide"
              key={license.LicenseIdentifier}
            >
              <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl">
                <div className=" tv-contactperson__item-text">
                  {license.LicenseTypeName}
                </div>
              </div>
              <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl ">
                <div className="tv-contactperson__item-text tv-license__number-of-licenses">
                  {license.NumberOfLicenses}
                  <Button
                    Text="- Nedgradera"
                    className={`tv-license__manage-license ${getLicenseOption('downgrade', license) ? 'tv-license__active' : 'tv-license__inactive'}`}
                    onClick={() => handleChangeLicense(license, 'downgrade')}
                    disabled={!getLicenseOption('downgrade', license)}
                  />
                  <Button
                    Text="+ Uppgradera"
                    className={`tv-license__manage-license ${getLicenseOption('upgrade', license) ? 'tv-license__active' : 'tv-license__inactive'}`}
                    onClick={() => handleChangeLicense(license, 'upgrade')}
                    disabled={!getLicenseOption('upgrade', license)}
                  />
                </div>
              </div>
              <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl edit-contact">
                <div className=" tv-contactperson__item-text">
                  {license.Price}
                </div>
              </div>
              <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl edit-contact">
                <div className=" tv-contactperson__item-text">
                  {moment(license.DateValidFrom).format('YYYY-MM-DD')}
                </div>
              </div>
              <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl edit-contact">
                <div className=" tv-contactperson__item-text">
                  {license.DateValidTo ? (
                    moment(license.DateValidTo).format('YYYY-MM-DD')
                  ) : (
                    <span
                      className="tv-contactperson__item-edit   text-center"
                      tabIndex={0}
                      role="button"
                      onKeyDown={e => {
                        if (e.key === 'Enter') handleCancelLicense(license);
                      }}
                      onClick={() => handleCancelLicense(license)}
                    >
                      Avsluta
                    </span>
                  )}
                </div>
              </div>
              <div
                className="col-12 col-xs-6  col-sm-6 col-md col-lg col-xl edit-contact"
                onClick={() =>
                  navigate('/ai-tolk/users', {
                    state: {
                      tabIndex: 1,
                      licenseIdentifier: license.LicenseIdentifier,
                      numberOfActiveUsers: license.NumberOfActiveUsers,
                      numberOfLicenses: license.NumberOfLicenses,
                      dateFirstCancellationPossible: license.DateFirstCancellationPossible,
                      licenseTypeName: license.LicenseTypeName,
                    },
                  })
                }
                tabIndex={0}
                onKeyDown={e => {}}
                role="button"
              >
                <div className="tv-contactperson__item-edit   text-center">
                  Användare
                </div>
              </div>
            </div>
            <div className="tv-contactperson-item--mobile flex-column mx-0 px-2 tv-display-mobile-show w-100 h-100">
              <div className="tv-reportquality__item-text tv-contactperson__item-text mt-2 pt-1 justify-content-between">
                <b className="tv-workassignment__detail-status text-capitalize">
                  {license.LicenseTypeName}
                </b>
                <div
                  onClick={() =>
                    navigate('/ai-tolk/users', {
                      state: {
                        tabIndex: 1,
                        licenseIdentifier: license.LicenseIdentifier,
                        numberOfActiveUsers: license.NumberOfActiveUsers,
                        numberOfLicenses: license.NumberOfLicenses,
                        dateFirstCancellationPossible: license.DateFirstCancellationPossible,
                        licenseTypeName: license.LicenseTypeName,
                      },
                    })
                  }
                  tabIndex={0}
                  role="button"
                  onKeyDown={e => {}}
                  className="tv-contactperson__item-text-focus"
                >
                  <div
                    className="tv-contactperson__item-edit   text-center"
                  >
                    Användare
                  </div>
                </div>
              </div>

              <div className="tv-workassignment__item-text tv-license__number-of-licenses">
                <div className="tv-workassignment__item-text-label">
                  <i className="fa fa-envelope mr-1" /> Antal:
                </div>
                {license.NumberOfLicenses}
                <Button
                  Text="- Nedgradera"
                  className={`tv-license__manage-license ${getLicenseOption('downgrade', license) ? 'tv-license__active' : 'tv-license__inactive'}`}
                  onClick={() => handleChangeLicense(license, 'downgrade')}
                  disabled={!getLicenseOption('downgrade', license)}
                />
                <Button
                  Text="+ Uppgradera"
                  className={`tv-license__manage-license ${getLicenseOption('upgrade', license) ? 'tv-license__active' : 'tv-license__inactive'}`}
                  onClick={() => handleChangeLicense(license, 'upgrade')}
                  disabled={!getLicenseOption('upgrade', license)}
                />
              </div>
              <div className="tv-workassignment__item-text">
                <div className="tv-workassignment__item-text-label">
                  <i className="fa fa-phone-alt mr-1" /> Månadskostnad:{' '}
                </div>
                {license.Price}
              </div>
              <div className="tv-workassignment__item-text">
                <div className="tv-workassignment__item-text-label">
                  <i className="fa fa-clock-o mr-1" /> Startdatum:{' '}
                </div>
                  {moment(license.DateValidFrom).format('YYYY-MM-DD')}
              </div>
              <div className="tv-workassignment__item-text">
                <div className="tv-workassignment__item-text-label">
                  <i className="fa fa-clock-o mr-1" /> Avslutsdatum:{' '}
                </div>
                {license.DateValidTo ? (
                  moment(license.DateValidTo).format('YYYY-MM-DD')
                ) : (
                  <span
                    className="tv-contactperson__item-edit   text-center"
                    tabIndex={0}
                    role="button"
                    onKeyDown={e => {
                      if (e.key === 'Enter') handleCancelLicense(license);
                    }}
                    onClick={() => handleCancelLicense(license)}
                  >
                    Avsluta
                  </span>
                )}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="tv-contactperson__item-text text-center w-100 py-4">
          Inga licenser tecknade
        </div>
      )}
    </div>
  );
}

function ManageLicense({
  licenses = [],
  showConfirmationMessage = false,
  hideConfirmation = () => {},
  licenseTypes = [],
  licenseError = [],
  licenseOperationSuccess = false,
  cleanLicenseError = () => {},
}) {
  const [selectedLicense, setSelectedLicense] = React.useState(null);
  const [showCancelLicense, setShowCancelLicense] = React.useState(false);
  const [showCreareLicense, setShowCreateLicense] = React.useState(false);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [isUpgrading, setIsUpgrading] = React.useState(false);
  const [isDowngrading, setIsDowngrading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [showError, setShowError] = React.useState(false);
  console.log("selectedLicense", selectedLicense);
  

  const navigate = useNavigate();
  const [existingLicenseIds, setExistingLicenseIds] = React.useState([]);

  const handleOpenCreate = () => {
    setExistingLicenseIds(licenses.map(l => l.LicenseIdentifier));
    setShowCreateLicense(true);
  };

  const handleGoToCreateUser = () => {
    const newLicense = licenses.find(
      l => !existingLicenseIds.includes(l.LicenseIdentifier),
    );
    if (newLicense) {
      navigate('/ai-tolk/users', {
        state: {
          tabIndex: 1,
          licenseIdentifier: newLicense.LicenseIdentifier,
          numberOfActiveUsers: newLicense.NumberOfActiveUsers,
          numberOfLicenses: newLicense.NumberOfLicenses,
          dateFirstCancellationPossible: newLicense.DateFirstCancellationPossible,
          licenseTypeName: newLicense.LicenseTypeName,
        },
      });
    } else {
      navigate('/ai-tolk/users', {
        state: { tabIndex: 1 },
      });
    }
  };

  const handleCancelLicense = license => {
    setSelectedLicense(license);
    setShowCancelLicense(true);
  };

  const handleChangeLicense = (license, option) => {
    setShowCreateLicense(true);
    setSelectedLicense(license);
    if (option === 'upgrade') {
      setIsUpgrading(true);
    }
    if (option === 'downgrade') {
      setIsDowngrading(true);
    }
  };

  const handleClose = () => {
    setShowCreateLicense(false);
    setSelectedLicense(null);
    setIsUpgrading(false);
    setIsDowngrading(false);
  };

  useEffect(() => {
    if (showConfirmationMessage) {
      setShowConfirmation(true);
    }
  }, [showConfirmationMessage]);

  useEffect(() => {
    if (licenseError && licenseError.length > 0) {
      const hasErrorCode1083 = licenseError.some(
        error => error.ErrorCode === 1083,
      );
      if (hasErrorCode1083) {
        setShowError(true);
        setError(licenseError[0].ErrorMessage);
      }
    }
  }, [licenseError]);

  useEffect(() => {
    if (licenseOperationSuccess) {
      handleClose();
    }
  }, [licenseOperationSuccess]);

  return (
    <>
      <div className="tv-aiTalk__panel-wrapper">
        <div className="col-12 px-0 mx-0 w-100">
          <div className="w-100 d-flex justify-content-end">
            <button
              className="tv_dashboard__add-button"
              type="button"
              onClick={handleOpenCreate}
            >
              <i className="fa fa-plus" /> Teckna licens
            </button>
          </div>
          <div className="row tv-reportquality__list-item-parent tv-reportquality__list-item-header d-none d-md-flex mb-0 custom">
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text">Licens</div>
            </div>
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text">Antal</div>
            </div>
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl edit-contact">
              <div className="tv-reportquality__item-text">Månadskostnad</div>
            </div>
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl edit-contact">
              <div className="tv-reportquality__item-text">Startdatum</div>
            </div>
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl edit-contact">
              <div className="tv-reportquality__item-text">Avslutsdatum</div>
            </div>
            <div className="col-12 col-xs-6 col-sm-6 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text" />
            </div>
          </div>
          <ManageLicenseList
            licenses={licenses}
            handleCancelLicense={handleCancelLicense}
            licenseTypes={licenseTypes}
            handleChangeLicense={handleChangeLicense}
          />
        </div>
      </div>
      <CreateLicense
        isVisible={showCreareLicense}
        onClose={handleClose}
        license={selectedLicense}
        isEdit={!!selectedLicense}
        title={
          isUpgrading
            ? 'Uppgradera licens'
            : isDowngrading
              ? 'Nedgradera licens'
              : 'Teckna licens'
        }
        upgrade={isUpgrading}
        downgrade={isDowngrading}
        callBack={() => {}}
      />
      <Confirmation
        isVisible={showConfirmation}
        onClose={() => {
          setShowConfirmation(false);
          hideConfirmation();
        }}
        onGoToCreateUser={handleGoToCreateUser}
      />
      <CancelLicense
        isVisible={showCancelLicense}
        onClose={() => {
          setShowCancelLicense(false);
          setSelectedLicense(null);
        }}
        selectedLicense={selectedLicense}
      />

      <ErrorModal
        isVisible={showError}
        onClose={() => {
          setError(null);
          setShowError(false);
          cleanLicenseError();
        }}
        errorMessage={error}
        onClick={() => {
          navigate('/ai-tolk/users', {
            state: {
              tabIndex: 1,
              licenseIdentifier: selectedLicense.LicenseIdentifier,
              licenseTypeName: selectedLicense.LicenseTypeName,
            },
          });
          setShowError(false);
          cleanLicenseError();
        }}
      />
    </>
  );
}

ManageLicense.prototype = {
  licenses: PropTypes.arrayOf(PropTypes.shape({})),
  showConfirmationMessage: PropTypes.bool,
  hideConfirmation: PropTypes.func,
  licenseTypes: PropTypes.arrayOf(PropTypes.shape({})),
  licenseError: PropTypes.arrayOf(PropTypes.shape({})),
  licenseOperationSuccess: PropTypes.bool,
  cleanLicenseError: PropTypes.func,
};

const mapStateToProps = state => ({
  licenses: state.user.profile.licenses || [],
  showConfirmationMessage: state.user.showConfirmation,
  licenseTypes: state.user.licenseTypes,
  licenseError: state.user.licenseError,
  licenseOperationSuccess: state.user.licenseOperationSuccess,
});
const mapDispatchToProps = dispatch => ({
  hideConfirmation: () => {
    dispatch(showConfirmation(false));
  },
  cleanLicenseError: () => {
    dispatch({
      type: FETCH_LICENSE_USERS_ERROR,
      errors: [],
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageLicense);
